import { variable } from './normalizer';

export function values(thisCondition) {
  const list = {};
  const flow = thisCondition.payment_flow;

  Object.keys(flow).forEach((item) => {
    const value = flow[item];

    if (!list[value]) {
      list[value] = [];
    }

    list[value].push(item);
  });

  return list;
}

export function frequent(thisValues) {
  return Object
    .keys(thisValues)
    .reduce((reduced, value) => {
      const { length } = thisValues[value];

      if (length > reduced.installments) {
        return {
          installments: length,
          value: parseInt(value, 10),
        };
      }

      return reduced;
    }, {
      installments: 0,
      value: 0,
    });
}

export function balloons(thisValues, thisInstallment) {
  const items = { ...thisValues };
  delete items[thisInstallment];

  return items;
}

export function ballooned(thisCondition) {
  return variable(thisCondition);
}

export function installment(thisBallooned, thisFrequent, thisCondition) {
  if (thisBallooned) {
    return parseInt(thisFrequent.value, 10);
  }

  return thisCondition.first_installment_value;
}

export function installments(thisBallooned, thisFrequent, thisCondition) {
  if (thisBallooned && thisFrequent.installments) {
    return thisFrequent.installments;
  }

  return thisCondition.installments;
}

export function minimum(thisCondition) {
  const {
    bank_minimum_down_payment: min,
    reason_identifier: reason,
  } = thisCondition;

  return min && reason === 'down_payment_less_than_minimum_value';
}

export default {
  computed: {
    values() {
      return values(this.condition);
    },
    balloons() {
      return balloons(this.values, this.installment);
    },
    frequent() {
      return frequent(this.values);
    },
    ballooned() {
      return ballooned(this.condition);
    },
    installments() {
      return installments(this.ballooned, this.frequent, this.condition);
    },
    installment() {
      return installment(this.ballooned, this.frequent, this.condition);
    },
    minimum() {
      return minimum(this.condition);
    },
  },
};
